module.exports = __webpack_public_path__ + "static/media/train-0-0-engine.b0b8bd7e.png";